<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Yaka</label>
            <v-select-list multiple :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Yaka"></v-select-list>
        </div>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'

export default {
    props:{
        value:Object
    },
    data(){
        return {
            collarStatuses:[]
        }
    },
    mounted(){
        this.getCollarStatuses()
    },
    methods:{
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
    },
    computed:{
        collarStatus:{
            get:function(){
                return this.collarStatuses.filter(s=>this.value.CollarStatusIds.includes(s.Id))
            },
            set:function(value){
                this.value.CollarStatusIds = value?.map(c=> c.Id) || null
            }
        }
    }
}
</script>